import { cn } from "@/lib/utils";

export function Skeleton({ className }: { className?: string }) {
	return <div className={cn("animate-pulse rounded-md bg-border/70", className)} />;
}

export function SkeletonRows({ rows }: { rows: number }) {
	return (
		<div className="flex flex-col divide-y divide-border/60">
			{Array.from({ length: rows }, (_, i) => (
				<div key={i} className="flex items-center gap-4 px-4 py-3">
					<Skeleton className="h-4 flex-1" />
					<Skeleton className="h-4 w-12" />
					<Skeleton className="h-4 w-24" />
					<Skeleton className="h-4 w-32" />
				</div>
			))}
		</div>
	);
}
